<div class="credo-page" [formGroup]="newEventForm">
  <main>
    <div class="card event-card">
      <div class="card-header">
        <h1 class="card-title">{{ "CALENDAR.ADD_EVENT" | translate }}</h1>
      </div>
      <div class="back-btn-wrap">
        <a [routerLink]="['/calendar']" class="back-btn">
          <span class="icon i-dropdown-arrow"></span>
          {{ "GENERAL.BACK" | translate }}
        </a>
      </div>

      <div class="card-body preloader-parent">
        <div class="card-block">
          <div class="card-block-title">
            {{ "CALENDAR.CHOOSE_LABEL" | translate }}
          </div>

          <div class="row-sm event-btn-row">
            <!-- <div class="col-6 col-md-auto">
              <button
                class="btn add-bill-btn"
                [ngClass]="{
                  selected: newEventForm.controls.eventType.value === 1
                }"
                (click)="pickEventType(1)"
              >
                <span>{{ "CALENDAR.UTILITY" | translate }}</span>
              </button>
            </div> -->
            <div class="col-6 col-md-auto">
              <button
                class="btn add-income-btn"
                [ngClass]="{
                  selected: newEventForm.controls.eventType.value === 4
                }"
                (click)="pickEventType(4)"
              >
                <span>{{ "CALENDAR.CUSTOM" | translate }}</span>
              </button>
            </div>
          </div>
        </div>

        <div class="card-block">
          <div class="card-block-title">
            {{ "GENERAL.DETAILS" | translate }}
          </div>

          <div class="row-sm fieldset">
            <div class="col-12 col-md-3 form-group">
              <input
                class="form-input"
                type="text"
                [placeholder]="'CALENDAR.EVENT_NAME'|translate"
                formControlName="eventName"
              />
            </div>
            <div class="col-12 col-md-3 form-group">
              <app-full-date-picker
                [pickedDate]="currentDate"
                [minDate]="currentDate"
                [maxDate]="maxDate"
                [placeholder]="'CALENDAR.CHOOSE_DATE'|translate"
                [valid]="true"
                [disabled]="false"
                (giveDate)="pickDate($event)"
              >
              </app-full-date-picker>
            </div>
            <div class="col-12 col-md-3 form-group">
              <input
                class="form-input"
                type="text"
                [placeholder]="'GENERAL.AMOUNT'|translate"
                formControlName="amount"
                digitOnly
              />
            </div>
            <div class="col-12 col-md-3 form-group">

            </div>
          </div>

          <div class="row-sm radio-fieldset">
            <div class="col-12 col-sm-auto form-group center-vertically">
              <label class="radio">
                <input
                  type="radio"
                  [value]="false"
                  formControlName="repeatEvent"
                />
                <span>{{ "CALENDAR.ONE_TIME" | translate }}</span>
              </label>
            </div>
            <div class="col-12 col-sm-auto form-group center-vertically">
              <label class="radio">
                <input
                  type="radio"
                  [value]="true"
                  formControlName="repeatEvent"
                />
                <span>{{ "CALENDAR.REPEAT_MONTHLY" | translate }}</span>
              </label>
            </div>
            <div
              class="col-12 col-sm-auto form-group center-vertically"
              *ngIf="newEventForm.controls.repeatEvent.value === true"
            >

              <app-select
                [loadingtext]="loadingSelectRepeatFrequencyText"
                [loading]="false"
                [newItem]="false"
                [choseElement]="pickedRepeatfrequency"
                [inputArray]="repeatArray"
                [showDropIcon]="true"
                (selectedItem)="pickRepeatFrequency($event)"
              ></app-select>
            </div>
          </div>
        </div>

        <div class="preloader full-screen double-circles" *ngIf="loading"></div>
      </div>

      <div class="card-footer">
        <div class="row-sm btn-row">
          <div
            class="col-12 col-md-auto"
            [ngClass]="{ disabled: newEventForm.invalid || loading }"
          >
            <button class="btn btn-primary btn-link" (click)="onSubmit()">
              {{ "GENERAL.ADD" | translate }}
            </button>
          </div>
          <div class="col-12 col-md-auto">
            <h4 style="color: #ea4c36" *ngIf="errorMessage">
              {{ "ERROR_CODES." + errorMessage | translate }}
            </h4>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
